import { PrincipalIdSchema } from "@core/domains/identity";
import { apiEndpoint, internalApi } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { ACCOUNT_SERVICE } from "../config/index.ts";
import { GithubConnection } from "../models/index.ts";

export const githubInternalApi = internalApi(
  { domain: API_DOMAIN, path: `${ACCOUNT_SERVICE.LABEL}/github/int` },
  {
    getAllGithubConnections: apiEndpoint({
      body: z.object(
        { principalId: PrincipalIdSchema },
        { principalId: "The id of the principal whose connections to return" },
      ),
      response: z.object(
        { items: z.array(GithubConnection.schema) },
        { items: "The principal's GitHub connections" },
      ),
    }),
    mintInstallationToken: apiEndpoint({
      body: z.object(
        {
          githubAccountId: z.int().nonnegative(),
          principalId: PrincipalIdSchema,
        },
        {
          githubAccountId: GithubConnection.descriptions.githubAccountId,
          principalId: GithubConnection.descriptions.principalId,
        },
      ),
      response: z.object(
        { installationToken: z.string() },
        {
          installationToken:
            "The access token of the connection's GitHub App installation",
        },
      ),
    }),
  },
);
